export default "__VITE_PUBLIC_ASSET__381379c8__"